import { render } from "./ModalFrame.vue?vue&type=template&id=3e6f9dc0&scoped=true"
import script from "./ModalFrame.vue?vue&type=script&lang=js"
export * from "./ModalFrame.vue?vue&type=script&lang=js"

import "./ModalFrame.vue?vue&type=style&index=0&id=3e6f9dc0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e6f9dc0"]])

export default __exports__